// Inside the useRentalGuardianProducts hook

import useSWR from "swr";
import { paths, API_URL } from "../config/endpoints";
import { RentalGuardianPayload } from "../types/rental-guardian/rental-guardian-payload";
import { RentalGuardianProductQuote } from "../types/rental-guardian/rental-guardian-res";

class CustomError {
  public message: string | null = null;
  constructor(private msg: string) {
    this.message = msg;
  }
}

const useRentalGuardianProducts = (
  uid: string,
  payload: RentalGuardianPayload,
  enabled: boolean
) => {
  const rentalGuardianProductsUrl = `${API_URL}/${paths.guest}/${paths.properties}/${uid}/${paths.rentalsGuardianProducts}`;

  const { data, error, isValidating } = useSWR<
    RentalGuardianProductQuote[],
    CustomError
  >(
    enabled ? [rentalGuardianProductsUrl, JSON.stringify(payload)] : null,
    async () => {
      const response = await fetch(rentalGuardianProductsUrl, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new CustomError("Error fetching rental guardian products");
      }

      const responseData = await response.json();
      return responseData;
    }
  );

  // Define the loading state based on isValidating
  const loading = isValidating;

  return { data, error, isValidating, loading }; // Include loading in the return object
};

export default useRentalGuardianProducts;
